module.exports = __webpack_public_path__ + "img/zalgiris-logo-icon.4c403056.png";